
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const CathetersSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("child-patient-assessment.catheters")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={2}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.existing-catheters")}>
            <Controller
              name="catheters.existingCatheters"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.iv-catheter-date")}>
            <Controller
              name="catheters.ivCatheterDate"
              control={control}
              render={({ field }) => (
                <ByzMuiDateTimePicker {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.umbilical-catheter-date")}>
            <Controller
              name="catheters.umbilicalCatheterDate"
              control={control}
              render={({ field }) => (
                <ByzMuiDateTimePicker {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("other")}>
            <Controller
              name="catheters.other"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Box>
  );
};
